import React, { useContext, useState } from 'react';
import { CartContext } from '../cart/ContextProvider';
import { logout } from '../Authentication/firebase'; // Import your logout function
import './Styles.css';
import { useNavigate } from 'react-router-dom';
import AccountCircleOutlinedIcon from '@mui/icons-material/Person';
import OrderPage from '../orderPage/orderDetail';

const ProfilePage = () => {
  const { user } = useContext(CartContext);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState('myOrders'); // Default selected option

  const handleLogout = () => {
    logout();
    // Redirect to the login page after logout
    navigate('/login');
  };

  const handleOrder = () =>{
    navigate('/orderPage')
  }

  // Check if user is null before accessing properties
  if (!user) {
    // Redirect to login if user is not logged in
    navigate('/login');
    return null;
  }


  function setOption(option) {
    setSelectedOption(option)
    console.log(selectedOption)
  };

  return (
    <div className="profile-container">
      {/* <div className='leftContent'>
        <div className="left-side">
          <div className="profile-info">
            <AccountCircleOutlinedIcon className="user-icon" style={{ fontSize: 40 }} />
            <div className="user-greeting">Hello, {user.displayName || user.name}</div>
          </div>
          <div className="options-box">
            <div className={`option ${selectedOption === 'myOrders' && 'selected'}`} onClick={() => setOption('myOrders')}>My Orders</div>
            <div className={`option ${selectedOption === 'coupons' && 'selected'}`} onClick={() => setOption('coupons')}>Coupons</div>
          </div>
        </div>
        <div className='logoutBtnDiv'>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div> */}

      <div className="right-side">
        {/* Content based on selected option */}
        {selectedOption === 'accountDetails' && <div className="account-details">Account Details Content</div>}
        {selectedOption === 'myOrders' && <div className="my-orders"><OrderPage/></div>}
        {selectedOption === 'coupons' && <div className="coupons">Coupons Content</div>}
        {/* Default content when no option is selected */}
      </div>

    </div>
  );
};

export default ProfilePage;